module.exports = __webpack_public_path__ + "img/MediaNet.2daa96f2.png";